// extracted by mini-css-extract-plugin
export var copyableField = "_or-4";
export var customerBadge = "_or-0";
export var customerInfoTitle = "_or-2";
export var details = "_or-1";
export var dropdownContainer = "_or-5";
export var dropdownImage = "_or-6";
export var editAssigneeForm = "_or-a";
export var editButton = "_or-3";
export var email = "_or-7";
export var hidden = "_or-d";
export var input = "_or-8";
export var saveButton = "_or-b";
export var shopifyIcon = "_or-c";
export var suggestionBadge = "_or-e";
export var suggestionText = "_or-f";
export var username = "_or-9";